import { useState, useEffect } from 'react';
import Navigation from '../home/components/Navigation';
import Footer from '../home/components/Footer';

export default function PrivacyPolicy() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation scrolled={scrolled} />
      
      <div className="pt-32 pb-20 px-6 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold text-[#1a2b4a] mb-4" style={{ fontFamily: 'Crimson Text, serif' }}>
            Privacy Policy
          </h1>
          
          <p className="text-[#1a2b4a]/60 text-sm mb-12">
            Effective Date: January 2025
          </p>

          <div className="prose prose-lg max-w-none space-y-8">
            <section>
              <p className="text-[#1a2b4a]/80 text-base leading-relaxed">
                Jerilyn Emerson and Progress Strategy Group ("we," "us," or "our") respect your privacy and are committed to protecting the personal information you share with us through this website.
              </p>
              <p className="text-[#1a2b4a]/80 text-base leading-relaxed mt-4">
                This Privacy Policy explains how we collect, use, and safeguard your information when you visit our website or communicate with us.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#1a2b4a] mb-4" style={{ fontFamily: 'Crimson Text, serif' }}>
                Information We Collect
              </h2>
              <p className="text-[#1a2b4a]/80 text-base leading-relaxed mb-4">
                We may collect personal information that you voluntarily provide when you:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-[#1a2b4a]/80 text-base">
                <li>Contact us through a form or email</li>
                <li>Schedule a consultation</li>
                <li>Subscribe to updates or resources</li>
                <li>Download materials or sign up for services</li>
              </ul>
              <p className="text-[#1a2b4a]/80 text-base leading-relaxed mt-4 mb-3">
                The information collected may include:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-[#1a2b4a]/80 text-base">
                <li>Name</li>
                <li>Email address</li>
                <li>Phone number</li>
                <li>Organization name</li>
                <li>Any information you choose to include in a message or inquiry</li>
              </ul>
              <p className="text-[#1a2b4a]/80 text-base leading-relaxed mt-6 mb-3">
                We may also automatically collect limited technical information when you visit the site, such as:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-[#1a2b4a]/80 text-base">
                <li>IP address</li>
                <li>Browser type</li>
                <li>Device information</li>
                <li>Pages visited</li>
                <li>Referring website</li>
              </ul>
              <p className="text-[#1a2b4a]/80 text-base leading-relaxed mt-4">
                This information is used to understand website usage and improve our services.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#1a2b4a] mb-4" style={{ fontFamily: 'Crimson Text, serif' }}>
                How We Use Your Information
              </h2>
              <p className="text-[#1a2b4a]/80 text-base leading-relaxed mb-3">
                We use the information we collect to:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-[#1a2b4a]/80 text-base">
                <li>Respond to inquiries and requests</li>
                <li>Provide consulting and coaching services</li>
                <li>Schedule meetings or consultations</li>
                <li>Send occasional updates, resources, or service information</li>
                <li>Improve the functionality and content of our website</li>
                <li>Maintain the security and performance of our systems</li>
              </ul>
              <p className="text-[#1a2b4a]/80 text-base leading-relaxed mt-4">
                <strong>We do not sell or rent your personal information to third parties.</strong>
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#1a2b4a] mb-4" style={{ fontFamily: 'Crimson Text, serif' }}>
                Sharing of Information
              </h2>
              <p className="text-[#1a2b4a]/80 text-base leading-relaxed mb-3">
                We may share information with trusted service providers who help operate our website and business services, such as:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-[#1a2b4a]/80 text-base">
                <li>Website hosting providers</li>
                <li>Email communication platforms</li>
                <li>Scheduling tools</li>
                <li>Analytics services</li>
              </ul>
              <p className="text-[#1a2b4a]/80 text-base leading-relaxed mt-4">
                These providers only receive the information necessary to perform their services and are expected to maintain confidentiality and security.
              </p>
              <p className="text-[#1a2b4a]/80 text-base leading-relaxed mt-4">
                We may also disclose information if required by law or to protect our legal rights.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#1a2b4a] mb-4" style={{ fontFamily: 'Crimson Text, serif' }}>
                Cookies and Analytics
              </h2>
              <p className="text-[#1a2b4a]/80 text-base leading-relaxed">
                Our website may use cookies or similar technologies to enhance your browsing experience and understand how visitors interact with the site.
              </p>
              <p className="text-[#1a2b4a]/80 text-base leading-relaxed mt-4">
                Cookies help us analyze website traffic and improve functionality. You may disable cookies through your browser settings if you prefer.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#1a2b4a] mb-4" style={{ fontFamily: 'Crimson Text, serif' }}>
                Data Security
              </h2>
              <p className="text-[#1a2b4a]/80 text-base leading-relaxed">
                We take reasonable administrative and technical measures to protect the personal information you provide. However, no internet transmission or electronic storage method is completely secure, and we cannot guarantee absolute security.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#1a2b4a] mb-4" style={{ fontFamily: 'Crimson Text, serif' }}>
                Third-Party Links
              </h2>
              <p className="text-[#1a2b4a]/80 text-base leading-relaxed">
                Our website may include links to third-party websites. We are not responsible for the privacy practices or content of those external sites.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#1a2b4a] mb-4" style={{ fontFamily: 'Crimson Text, serif' }}>
                Your Choices
              </h2>
              <p className="text-[#1a2b4a]/80 text-base leading-relaxed">
                You may choose not to provide personal information when visiting the website. However, certain features, such as contacting us or scheduling services, may require it.
              </p>
              <p className="text-[#1a2b4a]/80 text-base leading-relaxed mt-4">
                If you would like to request access to, update, or delete personal information you have provided, you may contact us using the information below.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#1a2b4a] mb-4" style={{ fontFamily: 'Crimson Text, serif' }}>
                Changes to This Policy
              </h2>
              <p className="text-[#1a2b4a]/80 text-base leading-relaxed">
                We may update this Privacy Policy from time to time to reflect changes in our practices or legal requirements. Updates will be posted on this page with the revised effective date.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#1a2b4a] mb-4" style={{ fontFamily: 'Crimson Text, serif' }}>
                Contact Information
              </h2>
              <p className="text-[#1a2b4a]/80 text-base leading-relaxed mb-3">
                If you have questions about this Privacy Policy or how your information is handled, please contact:
              </p>
              <div className="bg-[#f8f9fa] p-6 rounded-lg border border-[#2d9b9b]/20">
                <p className="text-[#1a2b4a] text-base font-semibold mb-2">Jerilyn Emerson</p>
                <p className="text-[#1a2b4a]/80 text-base">Progress Strategy Group</p>
                <p className="text-[#1a2b4a]/80 text-base mt-3">
                  Email: info@progressinaction.com
                </p>
                <p className="text-[#1a2b4a]/80 text-base mt-1">
                  Website: <a href="https://www.jerilynemerson.com" className="text-[#2d9b9b] hover:underline cursor-pointer">www.jerilynemerson.com</a>
                </p>
              </div>
            </section>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}